import { useDispatch } from 'react-redux';
import styles from './styles.module.scss';
import useTranslation from 'next-translate/useTranslation';
import { handleToggleGameButtonAnimation } from '@/lib/store/games-preferences/actions';

function GameButtonChip() {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();

  function onAnimationEnd() {
    dispatch(handleToggleGameButtonAnimation(false));
  }

  return (
    <div className={`${styles.chip}`} onAnimationEnd={onAnimationEnd}>
      <i className="fa-duotone fa-badge-check" />
      <div className={styles.chip__label}>{t('good_luck')}</div>
    </div>
  );
}
export default GameButtonChip;
